import { Injectable } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private translocoService: TranslocoService,
  ) {}

  t(text: string) {
    return this.translocoService.translate('auth-guard.' + text);
  }

  canActivate: CanActivateFn = (route, state) => {
    if (this.authService.isAuthenticated()) {
      return true;
    } else {
      this.authService.logout(this.t('Your session has expired. Please log in again to continue.'));
      return false;
    }
  };

  canActivateChild: CanActivateChildFn = (childRoute, state) => {
    return this.canActivate(childRoute, state);
  };
}
